import { useState } from 'react';
import { Button, Flex, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { useGetFormsOptions } from 'api/forms';
import {
  DetailsViewProperties as Properties,
  DetailsViewPropertiesContent as PropertiesContent,
  DetailsViewPropertiesHeader as PropertiesHeader,
} from 'components/shared';

import { AttachmentBox } from './AttachmentBox';
import { useFormEditContext } from '../../context';
import { AttachmentModal } from './AttachmentModal';

export const Attachments = () => {
  const { attachments, refetchAttachment } = useFormEditContext();
  const { data: options } = useGetFormsOptions();
  const { attachmentsLimit } = options || { attachmentsLimit: undefined };
  const [addModalOpened, setAddModalOpened] = useState(false);
  const { t } = useTranslation('forms');

  if (attachments === null || attachments === undefined) return null;

  const closeAttachmentModal = () => {
    setAddModalOpened(false);
    refetchAttachment();
  };

  return (
    <Properties>
      <PropertiesHeader title={t('editView.sidebar.attachments.title')}>
        <Button
          variant="default"
          disabled={attachments.length === attachmentsLimit}
          onClick={() => setAddModalOpened(true)}
        >
          {t('editView.sidebar.attachments.addButton')}
        </Button>
        <AttachmentModal
          opened={addModalOpened}
          onClose={closeAttachmentModal}
        />
      </PropertiesHeader>
      <PropertiesContent>
        <Text
          size="md"
          sx={theme => ({ marginBottom: theme.other.spacing(3) })}
        >
          {t('editView.sidebar.attachments.disclaimer', {
            attachmentsLimit,
          })}
        </Text>
        <Flex direction="column" gap="lg">
          {attachments.map(attachment => (
            <AttachmentBox key={attachment.id} attachment={attachment} />
          ))}
        </Flex>
      </PropertiesContent>
    </Properties>
  );
};
